export function popup () {

    $('.js-showpopup').click(function () {
        $('.overlay').addClass('overlayShow')
        $('.popup').addClass('popupShow')
    })

    $('.buttonPopupClose').click(function () {
        $('.overlay').removeClass('overlayShow')
        $('.popup').removeClass('popupShow')
    })
    $('.js-showitemPopup').click(function () {
        $('.overlay').addClass('overlayShow')
        $('.catalogItemPopupWrap').addClass('catalogItemPopupWrapOpen')
        $('.js-popupitem').addClass('catalogItemPopupShow')
    })

    $('.buttonItemPopupClose').click(function () {
        $('.js-popupitem').removeClass('catalogItemPopupShow')
        $('.catalogItemPopupWrap').removeClass('catalogItemPopupWrapOpen')
        $('.overlay').removeClass('overlayShow')
    })

}



/** WEBPACK FOOTER **
 ** ./assets/app/component/popup/popup.js
 **/